import selectors from '../../../rootSelectors';
import { playAvatarAudio, setAvatarInstructions } from '../../../common/avatar/avatarActions';
import {
    highlightDownButton,
    blockScreen,
    greyOutScreen,
    unblockScreen,
    greyOutOkButton,
    colorInOkButton,
} from '../../../common/screen/screenActions';
import { setIsReadyScriptPlayed, highlightMazeResponses } from '../../mazeActions';
import { SCROLL } from '../../../constants/assessmentItemType';
import { goToCountdown } from '../../../common/navigation/navigationActions';

export const narrateReadyScript = scrollInstructions => dispatch =>
    dispatch(
        playAvatarAudio([
            scrollInstructions.scrollIntroInstruction,
            scrollInstructions.scrollDownInstruction,
        ]),
    ).then(() => {
        dispatch(highlightDownButton());
    });

export const onNextButtonClick = (assessment, scrollInstructions) => (dispatch, getState) => {
    const state = getState();
    if (selectors.getMazeReadyForNextScript(state)) {
        return dispatch(goToCountdown(assessment));
    }
    dispatch(blockScreen());
    dispatch(greyOutScreen());
    dispatch(greyOutOkButton());
    return dispatch(
        playAvatarAudio([
            scrollInstructions.scrollReadyInstruction,
            scrollInstructions.scrollReadyClickOk,
        ]),
    ).then(() => {
        dispatch(
            setAvatarInstructions([
                scrollInstructions.scrollReadyInstruction,
                scrollInstructions.scrollReadyClickOk,
            ]),
        );
        dispatch(setIsReadyScriptPlayed(true));
        dispatch(unblockScreen());
        dispatch(colorInOkButton());
    });
};

export const highlightCorrectResponses = () => (dispatch, getState) => {
    const state = getState();
    const questions = selectors.getMazeQuestionItems(state, SCROLL);
    const responses = questions.reduce((result, item) => {
        const response = result;
        response[item.id] = item.correctResponse;
        return response;
    }, {});
    return dispatch(highlightMazeResponses(responses));
};
